import _ from 'lodash';
import { createContext } from 'react';

export const ToastContext = createContext({
  // Replicating the API from ant design:
  // https://ant.design/components/message/.
  message: {
    error: _.noop,
    success: _.noop,
  },
});
